import { lazy } from 'react';

const Login = lazy(() => import('../../components/pages/Login/Login'));
const Home = lazy(() => import('../../components/pages/Home/Home'));
const LogOut = lazy(() => import('../../components/pages/LogOut/LogOut'));
const UsersList = lazy(() =>
  import('../../components/pages/UsersList/UsersList'),
);
const EditUser = lazy(() => import('../../components/pages/EditUser/EditUser'));
const MyAccount = lazy(() =>
  import('../../components/pages/MyAccount/MyAcconut'),
);
const AddUser = lazy(() => import('../../components/pages/AddUser/AddUser'));
const ConfirmationAccount = lazy(() =>
  import('../../components/pages/ConfirmationAccount/ConfirmationAccount'),
);
const NotFound = lazy(() => import('../../components/pages/NotFound/NotFound'));

const AccessManagement = lazy(() =>
  import('../../components/pages/AccessManagement/AccessManagement'),
);

const SupportPage = lazy(() =>
  import('../../components/pages/Support/SupportPage'),
);

export const accountRoutes = [
  {
    path: '/support',
    access: 'authenticated',
    roles: null,
    Component: SupportPage,
  },
  {
    path: '/support/:id',
    access: 'authenticated',
    roles: null,
    Component: SupportPage,
  },
  {
    path: '/access-management',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: AccessManagement,
  },
  { path: '/login', access: 'guest', roles: null, Component: Login },
  { path: '/', access: 'authenticated', roles: null, Component: Home },
  { path: '/logout', access: 'public', roles: null, Component: LogOut },
  {
    path: '/users',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: UsersList,
  },
  {
    path: '/edit-user/:id',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: EditUser,
  },
  {
    path: '/account',
    access: 'authenticated',
    roles: null,
    Component: MyAccount,
  },
  {
    path: '/add-user',
    access: 'authenticated',
    roles: ['ADMIN'],
    Component: AddUser,
  },
  {
    path: '/verify/:token',
    access: 'public',
    roles: null,
    Component: ConfirmationAccount,
  },
  { path: '*', access: 'authenticated', roles: null, Component: NotFound },
];
